import apiClient, { unwrapData } from "./apiClient";

export async function getAnalyticsInsights(options = {}) {
  const { signal, query = {} } = options;
  const response = await apiClient.get("/api/analytics/insights", {
    signal,
    query,
  });

  return unwrapData(response) || {};
}

export async function getAnalyticsFilterOptions(options = {}) {
  const { signal } = options;
  const response = await apiClient.get("/api/analytics/filter-options", {
    signal,
  });

  return unwrapData(response) || {};
}
